import React from 'react';

import { Layout, Menu } from 'antd';
import css from './css.less';
import { changeSiderOpen } from '../../store';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import SubMenu from '@/src/components/Antd/Menu/MenuItem/SubMenu/Submenu';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import { instanceType, AllTypes } from 'src/tools/helper';
import { titleGenerator } from 'src/tools/helper';

import history from '../../../router/history';
import Link from 'src/components//Link/Link';
import ErrHOC from 'src/components/ErrorBoundary';
import { isUserValidOr } from 'src/tools/getUserInfo';
import { siderWidth } from 'src/tools/constant';

import _ from 'lodash';
import { getKeyPath, mapChildrenParent, mapMenuRouterKey } from './tools';
//import { menuArray } from '@/src/config/MainPageSIderConfig';
const { Sider } = Layout;
// interface IMenuOnclick {
//   key: string;
//   keyPath: string[];
//   domEvent;
//   item;
//   menuArray;
// }
import { useRequest } from 'ahooks';
import { getPendingReviewCount } from 'src/request/review';
import { get } from 'lodash';
const useReviewCount = (openKeys) => {
  const isOnProducts = (openKeys || []).includes('products');
  const { data, cancel, run } = useRequest(() => getPendingReviewCount(), {
    //ready: isOnProducts,
    // pollingInterval: 5000,
    manual: true,
  });
  React.useEffect(() => {
    if (!isOnProducts) {
      cancel();
    } else {
      run();
    }
  }, [isOnProducts]);
  const count = get(data, 'data.payload') || 0;

  return { count };
};

const SiderDemo = (props) => {
  const [selectedKey, setSelectedKey] = React.useState([]);
  const [openKeys, setOpenKeys] = React.useState([]);
  const { count } = useReviewCount(openKeys);
  // const isOnProducts = (openKeys || []).includes('products');
  // const { data, cancel, run } = useRequest(() => getPendingReviewCount(), {
  //   //ready: isOnProducts,
  //   pollingInterval: 5000,
  // });
  // React.useEffect(() => {
  //   console.log('123');
  //   if (!isOnProducts) {
  //     cancel();
  //   } else {
  //     run();
  //   }
  // }, [isOnProducts]);
  // const count = get(data, 'data.payload') || 0;
  // console.log('count', count);

  const { topPadding, menuArray: _m, trigger, siderClassName } = props;

  const collapsed = useSelector(
    (state: any) => state.mainLayout.isSiderCollapsed,
  );
  const _params: any = useParams();
  const menuArray = (
    (instanceType(_m) === AllTypes.Function
      ? _m(_params, {
          reviewCount: count,
        })
      : _m) || []
  ).filter((i) => {
    return !i.textOnly;
  });

  const entireMenu =
    instanceType(_m) === AllTypes.Function
      ? _m(_params, {
          reviewCount: count,
        })
      : _m;

  const throwEvent = React.useRef<any>();
  const menuRouterKey = React.useMemo(() => {
    // console.log(mapMenuRouterKey(menuArray, []) || {});
    return mapMenuRouterKey(menuArray, []) || {};
  }, [menuArray]); //路由对应的key

  const parentChildrenMap = React.useMemo(() => {
    return mapChildrenParent(menuArray);
  }, [menuArray]); //{key:[{key,path}]}
  const dispatch = useDispatch();

  // const [collapsed, setCollapsed] = React.useState(false);
  //const { location } = history;
  const location = useLocation();
  React.useEffect(() => {
    const { pathname } = location || {};

    const selected = menuRouterKey.find((i) => {
      const { reg } = i;

      return reg.test(pathname);
    });
    //console.log('selected', selected);
    //console.log(menuRouterKey, selected);
    if (selected) {
      const { key } = selected;
      const path = getKeyPath(key, menuArray, []); //[childKey,parentKey]
      const parentKey = path.slice(-1)[0];
      setOpenKeys([parentKey]);
      setSelectedKey(path);
    }
  }, [location]);
  React.useEffect(() => {
    return () => {
      if (throwEvent.current) clearTimeout(throwEvent.current);
      // addListen().unregisterListen()
    };
  }, []);

  const subMenuOnClick = (item) => {
    const { key: subMenuKey } = item;
    const childrenSet = parentChildrenMap[subMenuKey];
    if (!childrenSet) {
      setSelectedKey(['homepage']);
    }
    const currentSelect = _.cloneDeep(selectedKey);
    const key = currentSelect.shift();
    if (collapsed) {
      dispatch(changeSiderOpen(false));
    }
    if (childrenSet.map((i) => i.key).includes(key)) {
    } else {
      setOpenKeys([subMenuKey]);
      const target = childrenSet[0];
      const { path } = target || {};
      history.push(path);
      //setSelectedKey([key]);
    }
  };
  const Item = (props) => {
    const { children, ...rest } = props;

    return (
      <MenuItem
        {...rest}
        className={css.menuItem}
        onClickCommon={() => {
          if (collapsed) {
            dispatch(changeSiderOpen(false));
          }
        }}>
        {children}
      </MenuItem>
    );
  };
  const subMenuSupplyClassName = (key) => {
    if (collapsed && openKeys[0] === key) {
      return `ant-menu-item-selected`;
    } else {
      return '';
    }
  };
  const triggerComp = React.useMemo(() => {
    if (trigger) {
      //const _t = React.cloneElement(trigger, { open: !collapsed });
      return trigger;
    }
    return null;
  }, [trigger]);

  const renderMenu = (menuArray) => {
    return (
      <Menu
        theme='light'
        mode='inline'
        selectedKeys={selectedKey}
        openKeys={openKeys}>
        {menus(menuArray)}
      </Menu>
    );
  };

  const checkValid = ({ permissionGroup, source }) => {
    if (permissionGroup) {
      return isUserValidOr({ resourcesGroup: permissionGroup, source });
    }
    return true; //不设置就都是对的
  };

  const menus = (menuArray) =>
    menuArray.map((i, index) => {
      if (i.textOnly) {
        if (!i.splitLine) {
          return collapsed ? null : (
            <div
              key={index}
              className={css.textOnly}
              data-tester-title={titleGenerator(i.text)}>
              {i.text}
            </div>
          );
        } else {
          return <div className={css.splitLine} key={index} />;
        }
      } else {
        const permissionGroup = i.permissionGroup;
        const source = i.source;
        const isValid = checkValid({
          permissionGroup,
          source,
        });

        if (isValid) {
          if (i.sub) {
            return (
              <SubMenu
                key={i.key}
                icon={i.iconType}
                data-tester-title={titleGenerator(i.name)}
                title={titleGenerator(i.name)}
                collapsed={collapsed}
                onTitleClick={subMenuOnClick}
                id={i.key}
                className={subMenuSupplyClassName(i.key)}>
                {(i.sub || []).map((sub) => {
                  const permissionGroup = sub.permissionGroup;
                  const source = sub.source;
                  const isValid = checkValid({ permissionGroup, source });
                  return isValid ? (
                    <Item
                      key={sub.key}
                      id={sub.key}
                      icon={sub.iconType}
                      data-tester-title={titleGenerator(sub.name)}
                      onClick={() => {
                        // history.push(sub.path);
                      }}>
                      <Link to={sub.path}>{sub.name}</Link>
                    </Item>
                  ) : null;
                })}
              </SubMenu>
            );
          } else {
            return (
              <Item
                key={i.key}
                icon={i.iconType}
                data-tester-title={titleGenerator(i.name)}
                id={i.key}
                onClick={() => {
                  history.push(i.path);
                  //setOpenKeys([]);
                }}>
                <Link to={i.path}>{i.name}</Link>
              </Item>
            );
          }
        }
        return null;
      }
    });

  const groupMenuArrayByPosition = () => {
    const top_top = entireMenu.filter(
      (m) => m.position === 'top_top' || !m.position,
    );
    const top_bottom = entireMenu.filter((m) => m.position === 'top_bottom');
    const bottom_top = entireMenu.filter((m) => m.position === 'bottom_top');
    const bottom_bottom = entireMenu.filter(
      (m) => m.position === 'bottom_bottom',
    );
    return [top_top, top_bottom, bottom_top, bottom_bottom];
  };

  const [top1, top2, bottom1, bottom2] = groupMenuArrayByPosition();

  return (
    <Sider
      style={{
        height: `calc(100vh - ${topPadding}px)`,
        top: topPadding,
        paddingRight: collapsed ? 0 : 16,
      }}
      theme='light'
      className={`${css.sider} ${siderClassName || ''}`}
      collapsible
      collapsed={collapsed}
      onCollapse={(e) => {
        dispatch(changeSiderOpen(e));
        throwEvent.current = setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 1000);
      }}
      width={siderWidth}
      trigger={triggerComp}
      collapsedWidth={72}>
      <div className={css.menu}>
        {(top1.length !== 0 || top2.length !== 0) && (
          <div className={css.top}>
            {top1.length !== 0 && renderMenu(top1)}
            {top2.length !== 0 && renderMenu(top2)}
          </div>
        )}
        {(bottom1.length !== 0 || bottom2.length !== 0) && (
          <div className={css.bottom}>
            {bottom1.length !== 0 && renderMenu(bottom1)}
            {bottom2.length !== 0 && renderMenu(bottom2)}
          </div>
        )}
      </div>
    </Sider>
  );
};

export default ErrHOC(SiderDemo);
